function baseUrl(): string {
  return window.location.origin
}

export function currentUrl(): string {
  return window.location.href
}

export function externalPathRedirect(
  path?: string,
  query?: string,
  newTab?: boolean
): void {
  if (newTab) {
    window.open(
      `${baseUrl()}/${path ? path : ''}?${query ? query : ''}`,
      '_blank'
    )
  } else {
    window.location.href = `${baseUrl()}/${path ? path : ''}?${
      query ? query : ''
    }`
  }
}
